import { Component, OnInit, CUSTOM_ELEMENTS_SCHEMA, ViewChild, ElementRef } from '@angular/core';
import { ModalController, IonicModule } from '@ionic/angular';
import { DeviceBindComponent } from 'src/app/components/device-bind/device-bind.component';
import { GroupBindComponent } from 'src/app/components/group-bind/group-bind.component';
import { DeviceBindStoreService } from 'src/app/store/device-bind-store.service';
import { DmStoreService } from 'src/app/store/dm-store.service';
import { GroupBindStoreService } from 'src/app/store/group-bind-store.service';
import { UmStoreService } from 'src/app/store/um-store.service';

@Component({
  selector: 'app-bind',
  templateUrl: './bind.modal.html',
  styleUrls: ['./bind.modal.scss'],
  standalone: true,
  imports: [IonicModule, DeviceBindComponent, GroupBindComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class BindSwiperModalComponent implements OnInit {
  public segment = 0;
  public readonly SPEED = 300;

  @ViewChild('slides') swiperRef: ElementRef | undefined;

  constructor(
    private modalController: ModalController,
    private dmStore: DmStoreService,
    private groupBindStore: GroupBindStoreService,
    private deviceBindStore: DeviceBindStoreService,
    private umStore: UmStoreService,
  ) { }

  ngOnInit() {
    if (!this.umStore.projects.length) {
      this.umStore.fetchProjects({}, this.dmStore.preselectedValues.zoneId);
    }

    if (this.swiperRef) {
      this.swiperRef.nativeElement.swiper.disable();

      setTimeout(() => {
        if (this.dmStore.preselectedValues.deviceId || !this.groupBindStore.openGroupBindTab) {
          this.segment = 1;
        }

        this.swiperRef?.nativeElement.swiper.slideTo(this.segment);
      }, 200);

      this.swiperRef.nativeElement.swiper.slideTo(this.segment);
    }

  }

  public back() {
    this.modalController.dismiss();
    this.deviceBindStore.device = null;
  }

  segmentChanged() {
    this.swiperRef?.nativeElement.swiper.enable();
    this.segment = this.segment === 0 ? 1 : 0;
    this.swiperRef?.nativeElement.swiper.slideTo(this.segment);
    setTimeout(() => {
      this.swiperRef?.nativeElement.swiper.disable();
    }, this.SPEED);
  }

  touchStart() {
    this.swiperRef?.nativeElement.swiper.disable();
  }
}
